<form nz-form style="padding-top:12px;padding-right:12px" [formGroup]="validateForm" autocomplete="off" #form>
  <div nz-row [nzGutter]="['0','0']">
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="folkCode" nzRequired>Mã dân tộc</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input formControlName="folkCode" name="folkCode" type="text" placeholder="Nhập mã dân tộc" [jAutofocus]>
        </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item>
          <nz-form-label nzSpan="24" nzFor="folkName" nzRequired>Tên dân tộc</nz-form-label>
          <nz-form-control nzSpan="24" nzErrorTip="Vui lòng nhập trường bắt buộc!">
            <input nz-input formControlName="folkName" name="folkName" type="text" placeholder="Nhập tên dân tộc">
        </nz-form-control>
        </nz-form-item >
      </div>
      <div nz-col nzSm="24" nzMd="24">
        <nz-form-item> 
          <label nz-checkbox  formControlName="isNote" >Khác</label>
        </nz-form-item >
      </div>
  </div>
  <div *nzModalFooter>
    <div *ngIf="!isEditMode" class="card-footer text-right" >
      <popup-btn-footer [isDisableUpdate]="false" [isUpdateAndClose]="true" (updateAndClose)="UpdateClose()" (close)="close()"></popup-btn-footer>
    </div>
    <div *ngIf="isEditMode" class="card-footer text-right">
        <popup-btn-footer [isDisableUpdate]="false" [isUpdateAndClose]="true" (updateAndClose)="UpdateClose()" (close)="close()"></popup-btn-footer>
    </div>
  </div>
</form>